function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRoomGolfCourseViewFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.73 1.64H3c-.55 0-1 .45-1 1V28.5c0 .55.45 1 1 1h25.73c.55 0 1-.45 1-1V2.64c0-.55-.45-1-1-1zm-1 2v10.51c-5.97.08-10.86 1-14.68 2.19v-3l6.83-1.46c.42-.09.73-.43.78-.86.05-.42-.17-.83-.55-1.02l-7.62-3.74a.999.999 0 00-1.44.9v9.86c-.71.26-1.39.52-2.01.79-2.15.92-3.75 1.85-4.83 2.55-.08.05-.14.1-.22.15V3.64H27.73zm-14.68 7.65V8.76l3.59 1.76-3.59.77zM4 27.5v-4.55l.21-.17c.24-.18.6-.45 1.1-.77.99-.64 2.49-1.51 4.53-2.38.38-.16.8-.33 1.22-.49v3.92h2v-4.64c3.72-1.21 8.6-2.2 14.68-2.28v11.35H4v.01z",
    fill: props.color
  }));
}

export default SvgIconRoomGolfCourseViewFilled;